export const initialValuesClaveSeguridad = {
    rut: '',
    clave: '',
    beneficiario: false
}